
import { Component, Mixins } from "vue-property-decorator";
import {
  HisInformationItemDefaultSelectBehavior,
  HisInformationItemDefaultSelectKinds
} from "../../../../../../documaker/domain/format/objects";
import {
  IHisInformationItemDefaultSelectBehaviorPropertyEditable,
  instanceOfIHisInformationItemDefaultSelectBehaviorPropertyEditable
} from "../../../../../domain/editableFormat/properties";

@Component
export default class HisInformationItemDefaultSelectBehaviorPropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: IHisInformationItemDefaultSelectBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IHisInformationItemDefaultSelectBehaviorPropertyEditable) => T, defaultValue: T) => T;

  get isHisInformationItemDefaultSelectBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(
        s => instanceOfIHisInformationItemDefaultSelectBehaviorPropertyEditable(s) && s.hisInformationItemDefaultSelectBehavior().isEditable(),
        false
    );
  }

  get hisInformationItemDefaultSelectBehavior(): HisInformationItemDefaultSelectBehavior {
    return this.readPropertyOrDefault(
      s => HisInformationItemDefaultSelectBehavior.from(s.hisInformationItemDefaultSelectBehavior().getValue()),
      new HisInformationItemDefaultSelectBehavior(false, HisInformationItemDefaultSelectKinds.None)
    );
  }

  set hisInformationItemDefaultSelectBehavior(value: HisInformationItemDefaultSelectBehavior) {
    this.writePropertyWhenValid(s => s.hisInformationItemDefaultSelectBehavior().setValue(value));
  }

  get selectableHisInformationItemDefaultSelectKinds(): HisInformationItemDefaultSelectKinds[] {
    return this.readPropertyOrDefault(s => s.getSelectableHisInformationItemDefaultSelectKinds(), []);
  }
}
